const state = {
  showCreateDialog: false,
};

const actions = {
  toggleCreateDialog({ commit }, show) {
    commit("TOGGLE_CREATE_DIALOG", show);
  },
};

const mutations = {
  TOGGLE_CREATE_DIALOG: (state, show) => {
    state.showCreateDialog = show;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
